import React, {useContext} from 'react';
import {Button} from 'reactstrap';
import {FaEdit, FaExpandArrowsAlt, FaPlus, FaSync, FaTrashAlt} from "react-icons/fa";
import SweetAlert from "sweetalert2";
import {Link} from "react-router-dom";
import AuthorizationContext from "../../_helper/Authorization";
import type {AuthorizationContextType} from "../../_helper/Authorization/AuthorizationTypes";

interface iconBtnProps {
    type: string,
    confirm?: any,
    attrBtn?: any,
    link?: string,
    icon?: any,
    onclick?: () => void,
    permission?: string | string[],
}

const IconBtn = ({confirm, type, attrBtn, link, icon, onclick, permission}: iconBtnProps) => {
    const authContext = useContext(AuthorizationContext) as AuthorizationContextType;
    const {hasPermission} = authContext || {};
    const publicUrl = process.env.PUBLIC_URL || "";

    const normalizeLink = (target?: string) => {
        if (!target || !target.startsWith("/") || (publicUrl && target.startsWith(publicUrl))) {
            return target;
        }
        return `${publicUrl}${target}`;
    };

    if (permission) {
        const requiredPermissions = Array.isArray(permission) ? permission : [permission];
        const hasRequiredPermission = requiredPermissions.some((requiredPermission) => {
            return hasPermission ? hasPermission(requiredPermission) : false;
        });
        if (!hasRequiredPermission) return null;
    }

    const openConfirmAlert = () => {
        SweetAlert.fire({
            title: 'Are you sure?',
            text: confirm.text ? confirm.text : 'Once deleted, you will not be able to recover this!',
            icon: confirm.icon ? confirm.icon : 'warning',
            showCancelButton: confirm.showCancelButton ? confirm.showCancelButton : true,
            reverseButtons: confirm.reverseButtons ? confirm.reverseButtons : true,
            confirmButtonText: confirm.confirmButtonText ? confirm.confirmButtonText : 'Ok',
            cancelButtonText: confirm.cancelButtonText ? confirm.cancelButtonText : 'cancel',
        })
            .then((result: { value: any; }) => {
                if (result.value) {
                    onclick && onclick();
                }
            })
    }
    switch (type) {
        case 'delete':
            return <FaTrashAlt {...attrBtn} onClick={confirm ? openConfirmAlert : onclick && onclick()}
                               style={{cursor: "pointer", color: '#FC4438FF'}}/>
        case 'edit':
            return <FaEdit
                {...attrBtn} style={{cursor: "pointer", color: '#16C7F9FF'}}/>;
        case 'add':
            return <FaPlus {...attrBtn} style={{cursor: "pointer", color: '#7366FFFF'}}/>;
        case 'sync':
            return <FaSync {...attrBtn} style={{cursor: "pointer", color: '#1C012A'}}/>;
        case 'view':
            return <Link to={normalizeLink(link)}><FaExpandArrowsAlt
                {...attrBtn} style={{color: '#54BA4AFF'}}/></Link>;
        default:
            return <Button {...attrBtn} style={{padding: '0.375rem 0.75rem'}}>{icon}</Button>;
    }

};

export default IconBtn;
